import React, { useEffect } from "react";

function useTitle(title) {
  useEffect(() => {
    document.title = `${title} - GLTC`;
  }, [title]);
}

export default useTitle;
